import { CompanyOrdersGraphic } from "./graphics/CompanyOrdersGraphic"

export function ActiveOrdersStatistics() {
    return <CompanyOrdersGraphic />
}
